const propKeyRe = /^properties\[(.*)\]$/i;
export const createRawItemPayload = function(pairs) {
    return pairs.reduce(function(acc, { name , value  }) {
        if (name === 'properties') {
            return acc;
        }
        if (name.indexOf('properties') === 0) {
            if (propKeyRe.test(name) === false) {
                return acc;
            }
            const propKey = name.trim().replace(propKeyRe, '$1').trim();
            if (!propKey) {
                return acc;
            }
            acc.properties[propKey] = value;
            return acc;
        }
        acc[name] = value;
        return acc;
    }, {
        properties: {}
    });
};
